import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	description: {
		id: 'polaris-ideas.comments.limit-error.description',
		defaultMessage: 'Please review and remove existing comments to make space for new ones.',
		description: 'Description for the comments limit error banner.',
	},
});
